import Utils from "../../common/business/Utils";

class LandingUtils extends Utils {
}

export default new LandingUtils();
